const Reducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN_PROCESS':
      let data = action.payload.data;
      return {
        ...state,
        jwt: data.jwt,
        user: {
          name: data.user.forename || data.user.username || data.user.email,
          job_title: data.user?.job_title,
          uid: data.user.id
        },
        loading: false,
        success: true,
        error: false,
        status: action.payload.status,
        message: ''
      };

    case 'LOADING':
      return {
        ...state,
        success: false,
        loading: true,
        error: false
      };

    case 'LOGIN_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload.message[0].messages[0].message,
        status: action.payload.status
      };

    case 'TOKEN_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload.message,
        status: action.payload.status
      };

    case 'VERIFY_EMAIL':
      return {
        ...state,
        success: true,
        loading: false,
        error: false,
        status: action.payload.status,
        message: 'Account confirmation Email send. Please check your inbox'
      };

    case 'PROVIDER_LOGIN_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload.message,
        status: action.payload.status
      };

    case 'USER_LOGOUT':
      return {
        user: null,
        loading: false,
        error: false
      };

    case 'FORGOT_PASSWORD':
      return {
        ...state,
        success: true,
        loading: false,
        error: false,
        message: action.payload.data.ok
          ? 'Please check your Inbox to reset your password'
          : 'Somthing went wrong',
        status: action.payload.status
      };

    case 'GET_USER_DATA':
      return {
        ...state,
        profile: action.payload.data,
        success: true,
        loading: false,
        error: false,
        message: '',
        status: action.payload.status
      };

      case 'RESET_MESSAGE':
        return {
          ...state,
          success: false,
          loading: false,
          error: false,
          message: false,
        };

    case 'UPDATE_MESSAGE':
      return {
        ...state,
        success: false,
        loading: false,
        error: false,
        pendingItemsCount: (action?.payload?.pendingItemsCount || 0),
        message: (action?.payload?.message || "Profile Updated")
      };

      case 'GET_PENDING_ACTIONS_COUNT':
        return {
          ...state,
          pendingItemsCount: (action?.payload ? action.payload.length : 0) //Math.floor(Math.random() * 100) + 1,
        };

    case 'PROFILE_UPDATE':
      return {
        ...state,
        success: true,
        loading: false,
        error: false,
        profile: action.payload.data,
        message: action.payload.data ? 'Profile Updated' : action.payload.data,
        status: action.payload.status
      };

    case 'SERVICE_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload.message,
        status: action.payload.status
      };

    default:
      return state;
  }
};

export default Reducer;
